import { Entry } from '../Entry'

export function Entry20230219() {
  return (
    <Entry title="19/02/2023 - v3.3.5">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/13685/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
